import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const { company, refreshCompany } = useAuth();
  const [form, setForm] = useState({
    country: "IN", tax_mode: "india_gst", base_currency: "INR", default_tax_rate: 18,
  });

  useEffect(() => {
    if (company) {
      setForm({
        country: company.country || "IN",
        tax_mode: company.tax_mode || "india_gst",
        base_currency: company.base_currency || "INR",
        default_tax_rate: company.default_tax_rate || 18,
      });
    }
  }, [company]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/settings/company", { ...form, default_tax_rate: Number(form.default_tax_rate) });
      await refreshCompany();
      toast.success("Settings saved");
    } catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };

  return (
    <div className="max-w-3xl space-y-5 lb-fade" data-testid="settings-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Configuration</div>
        <h1 className="font-display font-extrabold text-3xl tracking-tight">Global Settings</h1>
        <p className="text-neutral-600 text-sm mt-1">Configure India GST vs Global VAT and default currency.</p>
      </div>

      <form onSubmit={submit} className="lb-card p-6 grid grid-cols-2 gap-4">
        <div>
          <label className="lb-label">Country</label>
          <select className="lb-select" value={form.country} data-testid="s-country"
                  onChange={(e) => setForm({ ...form, country: e.target.value })}>
            <option value="IN">India</option>
            <option value="US">United States</option>
            <option value="GB">United Kingdom</option>
            <option value="AE">UAE</option>
            <option value="SG">Singapore</option>
            <option value="AU">Australia</option>
            <option value="CA">Canada</option>
          </select>
        </div>
        <div>
          <label className="lb-label">Tax Mode</label>
          <select className="lb-select" value={form.tax_mode} data-testid="s-tax-mode"
                  onChange={(e) => setForm({ ...form, tax_mode: e.target.value })}>
            <option value="india_gst">India GST (CGST/SGST/IGST + IRN)</option>
            <option value="global_vat">Global VAT / Sales Tax</option>
            <option value="none">No Tax</option>
          </select>
        </div>
        <div>
          <label className="lb-label">Base Currency</label>
          <select className="lb-select" value={form.base_currency} data-testid="s-currency"
                  onChange={(e) => setForm({ ...form, base_currency: e.target.value })}>
            {["INR","USD","EUR","GBP","AED","SGD","AUD","CAD"].map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="lb-label">Default Tax Rate (%)</label>
          <input type="number" step="0.01" className="lb-input font-mono text-right"
                 value={form.default_tax_rate} data-testid="s-tax-rate"
                 onChange={(e) => setForm({ ...form, default_tax_rate: e.target.value })} />
        </div>
        <div className="col-span-2">
          <button className="lb-btn" data-testid="s-submit">Save Settings</button>
        </div>
      </form>

      <div className="lb-card p-5 text-sm text-neutral-600 bg-neutral-50">
        <strong>Note:</strong> Switching to Global VAT hides GST-specific fields (CGST/SGST/IGST split) and uses a flat tax percentage on invoices. IRN generation is only available in India GST mode.
      </div>
    </div>
  );
}
